"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  [![Run in Postman](https://run.pstmn.io/button.svg)](https://app.getpostman.com/run-collection/614feab5c108d292bffa#?env%5BStacks%20Blockchain%20API%5D=W3sia2V5Ijoic3R4X2FkZHJlc3MiLCJ2YWx1ZSI6IlNUMlRKUkhESE1ZQlE0MTdIRkIwQkRYNDMwVFFBNVBYUlg2NDk1RzFWIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJibG9ja19pZCIsInZhbHVlIjoiMHgiLCJlbmFibGVkIjp0cnVlfSx7ImtleSI6Im9mZnNldCIsInZhbHVlIjoiMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfdHgiLCJ2YWx1ZSI6IjIwMCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoibGltaXRfYmxvY2siLCJ2YWx1ZSI6IjMwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJ0eF9pZCIsInZhbHVlIjoiMHg1NDA5MGMxNmE3MDJiNzUzYjQzMTE0ZTg4NGJjMTlhODBhNzk2MzhmZDQ0OWE0MGY4MDY4Y2RmMDAzY2RlNmUwIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9pZCIsInZhbHVlIjoiU1RKVFhFSlBKUFBWRE5BOUIwNTJOU1JSQkdRQ0ZOS1ZTMTc4VkdIMS5oZWxsb193b3JsZFxuIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJidGNfYWRkcmVzcyIsInZhbHVlIjoiYWJjIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9hZGRyZXNzIiwidmFsdWUiOiJTVEpUWEVKUEpQUFZETkE5QjA1Mk5TUlJCR1FDRk5LVlMxNzhWR0gxIiwiZW5hYmxlZCI6dHJ1ZX0seyJrZXkiOiJjb250cmFjdF9uYW1lIiwidmFsdWUiOiJoZWxsb193b3JsZCIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWFwIiwidmFsdWUiOiJzdG9yZSIsImVuYWJsZWQiOnRydWV9LHsia2V5IjoiY29udHJhY3RfbWV0aG9kIiwidmFsdWUiOiJnZXQtdmFsdWUiLCJlbmFibGVkIjp0cnVlfV0=)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse200ToJSON = exports.InlineResponse200FromJSONTyped = exports.InlineResponse200FromJSON = void 0;
const runtime_1 = require("../runtime");
function InlineResponse200FromJSON(json) {
    return InlineResponse200FromJSONTyped(json, false);
}
exports.InlineResponse200FromJSON = InlineResponse200FromJSON;
function InlineResponse200FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accepted': !runtime_1.exists(json, 'accepted') ? undefined : json['accepted'],
        'block_height': !runtime_1.exists(json, 'block_height') ? undefined : json['block_height'],
        'domain': !runtime_1.exists(json, 'domain') ? undefined : json['domain'],
        'fully_qualified_subdomain': !runtime_1.exists(json, 'fully_qualified_subdomain') ? undefined : json['fully_qualified_subdomain'],
        'missing': !runtime_1.exists(json, 'missing') ? undefined : json['missing'],
        'owner': !runtime_1.exists(json, 'owner') ? undefined : json['owner'],
        'parent_zonefile_hash': !runtime_1.exists(json, 'parent_zonefile_hash') ? undefined : json['parent_zonefile_hash'],
        'parent_zonefile_index': !runtime_1.exists(json, 'parent_zonefile_index') ? undefined : json['parent_zonefile_index'],
        'resolver': !runtime_1.exists(json, 'resolver') ? undefined : json['resolver'],
        'sequence': !runtime_1.exists(json, 'sequence') ? undefined : json['sequence'],
        'signature': !runtime_1.exists(json, 'signature') ? undefined : json['signature'],
        'txid': !runtime_1.exists(json, 'txid') ? undefined : json['txid'],
        'zonefile_hash': !runtime_1.exists(json, 'zonefile_hash') ? undefined : json['zonefile_hash'],
        'zonefile_offset': !runtime_1.exists(json, 'zonefile_offset') ? undefined : json['zonefile_offset'],
    };
}
exports.InlineResponse200FromJSONTyped = InlineResponse200FromJSONTyped;
function InlineResponse200ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accepted': value.accepted,
        'block_height': value.block_height,
        'domain': value.domain,
        'fully_qualified_subdomain': value.fully_qualified_subdomain,
        'missing': value.missing,
        'owner': value.owner,
        'parent_zonefile_hash': value.parent_zonefile_hash,
        'parent_zonefile_index': value.parent_zonefile_index,
        'resolver': value.resolver,
        'sequence': value.sequence,
        'signature': value.signature,
        'txid': value.txid,
        'zonefile_hash': value.zonefile_hash,
        'zonefile_offset': value.zonefile_offset,
    };
}
exports.InlineResponse200ToJSON = InlineResponse200ToJSON;
//# sourceMappingURL=InlineResponse200.js.map